import mutations from "./mutations";
import * as actions from "./actions";

let state = {
    items: [],
    unreadCount: 0
};

export default {mutations, actions, state}
